// please keep this sorted alphabetically
import alertTypes from "./alert";
import bankSearch from "./bank-search/BankSearch";
import buttonTypes from "./button";
import CommunicationConsent from "./communication-consent/CommunicationConsent";
import ContactInfo from "./contact-info/ContactInfo";
import CreditCardReductionAlertCountdown from "./banners/CreditCardReductionAlertCountdown";
import Disclosure from "./disclosure/Disclosure";
import forms from "./forms";
import AppFooter from "./footer/Footer";
import AppMasthead from "./masthead/AppMasthead";
import * as GoogleAddressActions from "./google-address-verify/actions/google-address-verify";
import * as GoogleAddressSelectors from "./google-address-verify/state-selectors/google-address-verify";
import GoogleAddressVerify from "./google-address-verify/GoogleAddressVerify";
import googleAddressVerifyStore from "./google-address-verify/googleAddressVerifyStore";
import Graph from "./graph/Graph";
import IntervalManager from "./interval-manager/IntervalManager";
import IFrame from "./i-frame-wrapper";
import Loading from "./loading/Loading";
import Media from "./media/Media";
import MessageNotifier from "./message-notifier/MessageNotifier";
import Overlays from "./overlays";
import QueryConsumer from "./query-consumer"
import ScriptLoader, { scripts } from "./script-loader/ScriptLoader";
import Select from "./select/Select";
import Tooltip from "./tooltip/Tooltip";
import Uploader from "./uploader/Uploader";
import Rlab from "./rlab/Rlab";
import RlabReducer from "./rlab/reducers/rlab-reducer";
import * as RlabTypes from "./rlab/types/rlab-types";
import * as ReactSpark from "react-spark";
import redux from "./redux";
import { offersSchema, offerSchema } from "./offers-page-schemas";
import offers from "./offers";
import routing from "./routing";
import icons from "./icons";

const {
  Accordion,
  Box,
  Dictionary,
  Divider,
  Footer,
  Icon,
  Link,
  Masthead,
  Modal,
  Spinner,
  Stack,
  Toggle,
  Type,
  List,
  Card,
  Table,
  Alert
} = ReactSpark;

// please keep this sorted alphabetically
const components = {
  Accordion,
  alert: alertTypes, // DEPRECATED
  Alert,
  bankSearch,
  Box,
  button: buttonTypes,
  communicationConsent: CommunicationConsent,
  ContactInfo,
  CreditCardReductionAlertCountdown,
  Dictionary,
  disclosure: Disclosure,
  Divider,
  AppFooter,
  AppMasthead,
  Footer,
  forms,
  googleAddressActions: GoogleAddressActions,
  googleAddressSelectors: GoogleAddressSelectors,
  googleAddressVerify: GoogleAddressVerify,
  googleAddressVerifyStore,
  graph: Graph,
  Icon,
  icons,
  IFrame,
  intervalManager: IntervalManager,
  loading: Loading,
  Link,
  List,
  Masthead,
  Modal,
  media: Media,
  messageNotifier: MessageNotifier,
  overlays: Overlays,
  QueryConsumer,
  rlab: {
    Rlab,
    RlabReducer,
    RlabTypes
  },
  scriptLoader: {
    ScriptLoader,
    scripts
  },
  // This `select` is deprecated. You might be looking for `forms/select`
  select: Select,
  Spinner,
  Stack,
  Toggle,
  Tooltip,
  Type,
  uploader: Uploader,
  Card,
  Table,
  redux,
  offersSchema,
  offerSchema,
  offers,
  routing
};

export default components;
